/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
//;
import './Modal.scss';
import { CountryDropdown, RegionDropdown } from "react-country-region-selector"
import timezoneArray from 'data/timezone.js'
import currencyArray from 'data/currency.js'
import registerSchool from 'controllers/school/registerSchool'
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber';

import locale from './locale'
const DEFAULT_REGION_CODE = 'ca';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      params: {
        title: '',
        description: '',
        schoolType: 0,
        country: 'Canada',
        province: 'British Columbia',
        city: '',
        timezone: 'America/Vancouver',
        currency: 'CAD',
        suitAgeLower: '',
        phone: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE},
        email: '',
      }
    }

    this.onChange = this.onChange.bind(this);
  }

  onChange(name) {
    return (e)=>{
      let {
        onFormChange,
      } = this.props;

      if(name == 'suitAgeLower'){
        if(e.target.value > 0){
          return this.setState({
            params: {
              ...this.state.params,
              [name]: e.target.value
            }
          }, () => {onFormChange(this.state)})
        }
      } else if (name == 'country'){
        return this.setState({
          params: {
            ...this.state.params,
            [name]: e
          }
        }, () => {onFormChange(this.state)})
      } else if (name =='province'){
        return this.setState({
          params: {
            ...this.state.params,
            [name]: e
          }
        }, () => {onFormChange(this.state)})
      } else if (name == 'phone'){
        return this.setState({
          params: {
            ...this.state.params,
            [name]: e
          }
        }, () => {onFormChange(this.state)})
      }

      this.setState({
        params:{
          ...this.state.params,
          [name]: e.target.value,
        }
      }, ()=>{
        onFormChange(this.state)
      });
    }
  }

  selectTimeZone(){
    let timezone = []
    for (let i = 0; i < timezoneArray.length; i++) {
      timezone.push(<option key={i} value={timezoneArray[i]}>{timezoneArray[i]}</option>)
    }
    return (
      <select type='text' className='form-control' value={this.state.timezone} onChange={this.onChange('timezone')} >
        {timezone}
      </select>
    )
  }

  renderCurrency() {
    let currency2 = []
    for (let i = 0; i < currencyArray.length; i++) {
      currency2.push(<option key={i} value={currencyArray[i].code} >{currencyArray[i].code}</option>)
    }
    return (
      <select type='text' className='form-control' value={this.state.params.currency} onChange={this.onChange('currency')} >
        {currency2}
      </select>
    )
  }

  render() {
    return (
      <div className='custom-modal-content'>
        <div className='col-lg-6 col-md-6 create-school-input-left'>
          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('School Name', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.title ? require('data/images/Group@2x.png') : require('data/images/1@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <input type='text' className='form-control' placeholder='' value={this.state.params.title} onChange={this.onChange('title')}/>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('School Description', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.description ? require('data/images/Group@2x.png') : require('data/images/2@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <textarea type='text' className='form-control' value={this.state.params.description} onChange={this.onChange('description')} />
            </div>
          </div>

          {/* <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('School Type', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={require('data/images/Group@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <select type='text' className='form-control' value={this.state.params.schoolType} onChange={this.onChange('schoolType')} >
                <option value='0'>{__('After School Class', 'appwrapper')}</option>
                <option value='1'>{__('Pre School', 'appwrapper')}</option>
                <option value='2'>{__('Tutor', 'appwrapper')}</option>
                <option value='3'>{__('Public/Private School', 'appwrapper')}</option>
              </select>
            </div>
          </div> */}

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('Student Enrollment Age Limit', 'appwrapper')}  </label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.suitAgeLower ? require('data/images/Group@2x.png'): require('data/images/3@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <input type='number' min="0" placeholder='0' className='form-control' value={this.state.params.suitAgeLower} onChange={this.onChange('suitAgeLower')} />
              <span className='pull-right age'>{__('Years Old', 'appwrapper')}</span>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('School Email', locale)}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.params.email) ? require('data/images/Group@2x.png'): require('data/images/4@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <input type='email' className='form-control' value={this.state.params.email} onChange={this.onChange('email')} />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('School Phone No.', locale)}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.phone.national_number.length > 5 ? require('data/images/Group@2x.png'): require('data/images/5@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <ReactPhoneInput className='form-control' value={this.state.params.phone} onChange={this.onChange('phone')} defaultCountry={'ca'} />
            </div>
          </div>

        </div>

        <div className='col-lg-6 col-md-6 create-school-input-right'>
          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('Country', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={require('data/images/Group@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <CountryDropdown
                defaultOptionLabel='Canada'
                value={this.state.params.country}
                classes='form-control'
                onChange={this.onChange('country')}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('Province/States', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.province ? require('data/images/Group@2x.png') : require('data/images/6@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <RegionDropdown
                defaultOptionLabel='select a region'
                country={this.state.params.country}
                value={this.state.params.province}
                classes='form-control'
                onChange={this.onChange('province')}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12' style={{marginTop: '19px'}}>
              <label className='pull-left'>{__('City', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={this.state.params.city ? require('data/images/Group@2x.png') : require('data/images/8@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              <input type='text' className='form-control' value={this.state.params.city} onChange={this.onChange('city')} />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('Time Zone (Cannot Change After Saved)', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={require('data/images/Group@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              {this.selectTimeZone()}
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <label className='pull-left'>{__('Currency (Cannot Change After Saved)', 'appwrapper')}</label>
            </div>
            <div className='col-md-3 school-name'>
              <img className='school-success-icon' src={require('data/images/Group@2x.png')} />
            </div>
            <div className='col-md-9 school-name-input'>
              {this.renderCurrency()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/CreateSchool/ModalContent.js